import { Context } from "./_context";
import { useHooks } from "./_hook";
import { PopupProviderProps } from "./_types";

/**
 * Popup Provider - view
 */
export default function (props: PopupProviderProps) {
  const context = useHooks(props);
  return <Context.Provider value={context}>{props.children}</Context.Provider>;
}
